import { Component, OnInit, Input } from '@angular/core';
import { CivilCase } from './../../../civil/civil-case';

@Component({
  selector: 'app-transcript',
  templateUrl: './transcript.component.html',
  styleUrls: ['./../civil-case-view.component.less']
})
export class TranscriptComponent implements OnInit {

  @Input() civilCase: CivilCase;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/civil/transcript/transcript.component.ts